import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "protection-overview-eis-trend",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "One tenant's monthly Event Integrity Score trend for one report edition.",
    domain: "reports",
    visual: "Line chart",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
